import { Box, Typography } from '@mui/material';
import React from 'react';
import StyledBox from './styles';

function Progress(props: { duration: number }) {
  const { duration } = props;
  const [progress, setProgress] = React.useState(Math.floor(duration / 1000));

  React.useEffect(() => {
    const timerId = setInterval(() => {
      setProgress((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [progress]);

  return (
    <Box>
      <Typography variant="h4">
        {progress}
        s
      </Typography>
    </Box>
  );
}

export default function ActivityChangeContent(props: {
  duration: number,
  title: string,
  body: string,
}) {
  const { duration, title, body } = props;
  return (
    <StyledBox>
      <Progress duration={duration} />
      <Typography variant="h6">
        {title}
      </Typography>
      <Typography variant="body1">
        {body}
      </Typography>
    </StyledBox>
  );
}
